import type {Transition, Variants} from 'framer-motion';

// Shared entrance motion lifted from the planner home page so other top-level
// views (e.g. the Encounter Review in PostSessionNotesView) can load in with
// the exact same gentle fade rather than inventing their own curve. Keeping
// the curve in one place is what makes navigating between the planner and a
// detail view feel like one continuous app instead of a set of pages that each
// pop in differently.

// The planner's signature ease-out curve. A soft, slightly overshooting
// ease-out that lets content settle into place rather than snapping.
export const PLANNER_MOTION_EASE = [0.22, 1, 0.36, 1];
export const PLANNER_MOTION_EASE_CSS = 'cubic-bezier(0.22, 1, 0.36, 1)';

// Matches the planner home page entrance timing.
export const PLANNER_VIEW_ENTRANCE_DURATION_MS = 220;

export const PLANNER_VIEW_ENTRANCE_TRANSITION: Transition = {
  duration: PLANNER_VIEW_ENTRANCE_DURATION_MS / 1000,
  ease: PLANNER_MOTION_EASE,
};

// The planner home page enters as a pure fade. A few pixels of upward drift are
// added here so views that load their content asynchronously (a note arriving
// after a loader) read as "settling in" rather than blinking on, while staying
// on the same curve and timing as the planner home.
export const PLANNER_VIEW_ENTRANCE_VARIANTS: Variants = {
  initial: {opacity: 0, y: 8},
  animate: {opacity: 1, y: 0},
  exit: {opacity: 0, y: -8},
};
